import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-387592b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-table__header" }
const _hoisted_2 = { class: "view-table__description" }
const _hoisted_3 = { class: "view-table__pagination" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Страница", -1))
const _hoisted_5 = ["max"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "из", -1))
const _hoisted_7 = {
  key: 0,
  class: "table is-bordered"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "th-name-file" }, "Имя документа"),
    /*#__PURE__*/_createElementVNode("th", { class: "th-other" }, "Дата создания"),
    /*#__PURE__*/_createElementVNode("th", { class: "th-other" }, "Действие")
  ])
], -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "control download-button" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "table-container__empty"
}
const _hoisted_14 = {
  key: 0,
  class: "view-table_options"
}
const _hoisted_15 = { class: "view-table_options__content box is-radiusless" }
const _hoisted_16 = { class: "field mt-auto" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Показывать по", -1))
const _hoisted_18 = { class: "control" }
const _hoisted_19 = { class: "select" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Сортировка", -1))
const _hoisted_23 = { class: "control" }
const _hoisted_24 = { class: "select" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "view-table_options__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, "Всего найдено " + _toDisplayString(_ctx.ctx.meta.total), 1),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "number",
          min: "1",
          max: _ctx.ctx.meta.page.total,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePage && _ctx.changePage(...args)))
        }, null, 40, _hoisted_5), [
          [_vModelText, _ctx.page]
        ]),
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_ctx.ctx.meta.page.total), 1)
      ]),
      _createElementVNode("button", {
        class: "button is-info",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showOptions = true))
      }, "Опции")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["table-container with-scrollbar", {'busy':_ctx.ctx.isLoading, 'lock': _ctx.showOptions}]),
      id: "table"
    }, [
      (_ctx.ctx.list.length)
        ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.list, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.created_at)), 1),
                  (item.deleted_at)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                        _createElementVNode("p", null, "Удалён " + _toDisplayString(_ctx.formatDate(item.deleted_at)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.download(item.id, item.name))
                          }, "Скачать", 8, _hoisted_12)
                        ])
                      ]))
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_13, "Пусто"))
    ], 2),
    (_ctx.showOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", {
            class: "view-table_options__overlay",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("p", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.limit) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.LimitPageVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant.value,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_20))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.limit]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("p", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sorting) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.sortingVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_25))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.sorting]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "button is-primary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
              }, "Применить"),
              _createElementVNode("button", {
                class: "button is-ghost",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
              }, "Сбросить"),
              _createElementVNode("button", {
                class: "button is-light",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, "Отмена")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}